import React from "react";
import "./GameChoose.css";
import "../Gamecommon.css";
import gameimg7 from "../gameassets/gameimg7.png";
import gamechooseimg from '../gameassets/gamechooseimg.png';

export default function GameChoose() {
  return (
    <div id="gamechoose" className="gamemainclass">
      <span className="span-tag">Our Development Process</span>
      <h2 className="h2-tag">
       Instead of just listing services, we frame them as tailored solutions for client needs.
      </h2>
      <p className="p-tag">
     We don’t just make games — we craft adventures. </p>
      <div className="bottom">             
        <div className="left">
          {/* <img src={gameimg7} alt="error" /> */}
          <img src={gamechooseimg} alt="error" />
        </div>
        <div className="right">
          <div className="content-main">
            <div className="list">
              <div className="number number1">
                <span>01</span>
              </div>
              <div className="content">
                <h3>Concept & Prototyping</h3>
                <p>
                 From idea to early builds, we create game design documents (GDDs) and prototypes to validate mechanics and gameplay.
                </p>
              </div>
            </div>
            <div className="list">
              <div className="number">
                <span>02</span>
              </div>
              <div className="content">
                <h3>Art & Asset Creation</h3>
                <p>
                Characters, environments, UI, and 2D/3D animation that bring your world to life.
                </p>
              </div>
            </div>
            <div className="list">
              <div className="number">
                <span>03</span>
              </div>
              <div className="content">
                <h3>Core Development </h3>
                <p>
                 Coding the engine, AI, multiplayer systems, and monetization models.
                </p>
              </div>
            </div>
            <div className="list">
              <div className="number">
                <span>04</span>
              </div>
              <div className="content">
                <h3>Testing & Balancing </h3>
                <p>
                 Rigorous QA to ensure smooth gameplay, scalability, and performance.
                </p>
              </div>
            </div>
            <div className="list">
              <div className="number">
                <span>05</span>
              </div>
              <div className="content">
                <h3>Launch & Live Support</h3>
                <p>
                 Successful deployment with ongoing updates, expansions, and live ops to keep players engaged.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
